export default __webpack_public_path__ + "static/media/Wizards.57179227.jpg";